import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-4 flex-wrap">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center">
            {index > 0 && (
              <i className="ri-arrow-right-s-line mx-2 text-foreground-400"></i>
            )}
            {isLast || !item.href ? (
              <span className={isLast ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.href}
                className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}